import CheckIcon from "@mui/icons-material/Check";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {Box, CircularProgress, IconButton, Stack, Tooltip} from "@mui/material";
import type {AggregationSurveySubmissionListItem}
    from "crqlar-react-common/dist/models/aggregation/surveyAggregation.model";
import {SurveyReviewState} from "crqlar-react-common/dist/models/survey/surveySubmission.model";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {SURVEY_REVIEW_STATE_LABEL_KEYS} from "../../common/uiElements/SurveyReviewStateElement";

interface Props {
    submission: AggregationSurveySubmissionListItem
    markReviewedBusy?: boolean
    markReviewedDisabled?: boolean
    onView: () => void
    onMarkReviewed?: () => void
}

/**
 * View, and the review mark: an open reply is resolved in one click, a resolved one only shows
 * its check - reopening is a deliberate change made in the dialog.
 */
const SubmissionActionsCell = ({
    submission,
    markReviewedBusy,
    markReviewedDisabled,
    onView,
    onMarkReviewed
}: Props) => {
    const {t} = useLocalize();
    const reviewed = submission.reviewState === SurveyReviewState.REVIEWED;

    return (
        <Stack direction={'row'} alignItems={'center'} gap={0.5} data-no-row-click>
            <Tooltip title={t('View submission')}>
                <IconButton size={'small'} onClick={onView}>
                    <VisibilityIcon fontSize={'small'}/>
                </IconButton>
            </Tooltip>

            {!!onMarkReviewed && (reviewed ? (
                <Tooltip title={t(SURVEY_REVIEW_STATE_LABEL_KEYS[SurveyReviewState.REVIEWED])}>
                    {/* The small icon button's own padding, so both marks sit in the same spot. */}
                    <Box component={'span'} sx={{display: 'inline-flex', p: '5px'}}>
                        <CheckIcon fontSize={'small'} color={'success'}/>
                    </Box>
                </Tooltip>
            ) : (
                <Tooltip title={t('Mark as resolved')}>
                    <span>
                        <IconButton
                            size={'small'}
                            aria-label={t('Mark as resolved')}
                            disabled={markReviewedDisabled}
                            onClick={onMarkReviewed}
                        >
                            {markReviewedBusy
                                ? <CircularProgress size={16}/>
                                : <InfoOutlinedIcon fontSize={'small'} color={markReviewedDisabled ? 'inherit' : 'warning'}/>}
                        </IconButton>
                    </span>
                </Tooltip>
            ))}
        </Stack>
    );
};

export default SubmissionActionsCell;
